export const guidance = {
  en: {
    widget: {
      title: "SOLARIIS Guide",
      subtitle: "Your service assistant",
      tooltip: "Continue conversation",
    },
    chat: {
      loadError: "Error loading conversation",
      retry: "Retry",
      requestInProcess: "Your request {number} is being processed.",
      suggestion1: "I want to share more details",
      suggestion2: "I have a question",
      suggestion3: "View my options",
      requestLabel: "Request:",
      loading: "Loading...",
      loadEarlier: "Load earlier messages",
      placeholder: "Type your message...",
    },
    formPreview: {
      projectName: "Project Name",
      company: "Company",
      projectOverview: "Project Overview",
      budget: "Budget Range",
      timeline: "Timeline",
      projectSummary: "Project Summary",
      title: "Your Request",
      selectService: "Select a service",
      confidenceHigh: "High",
      confidenceMedium: "Medium",
      confidenceLow: "Low",
      aiSuggested: "AI suggested",
      confirmed: "Confirmed",
      confirm: "Confirm",
      edit: "Edit",
      discard: "Discard",
      pending: "Pending...",
      continueToFull: "Continue to Full Questionnaire",
      viewDetails: "View Request Details",
    },
  },
  es: {
    widget: {
      title: "Guía SOLARIIS",
      subtitle: "Tu asistente de servicios",
      tooltip: "Continuar conversación",
    },
    chat: {
      loadError: "Error al cargar la conversación",
      retry: "Reintentar",
      requestInProcess: "Tu solicitud {number} está en proceso.",
      suggestion1: "Quiero compartir más detalles",
      suggestion2: "Tengo una pregunta",
      suggestion3: "Ver mis opciones",
      requestLabel: "Solicitud:",
      loading: "Cargando...",
      loadEarlier: "Cargar mensajes anteriores",
      placeholder: "Escribe tu mensaje...",
    },
    formPreview: {
      projectName: "Nombre del Proyecto",
      company: "Empresa",
      projectOverview: "Descripción del Proyecto",
      budget: "Presupuesto",
      timeline: "Plazo",
      projectSummary: "Resumen del Proyecto",
      title: "Tu Solicitud",
      selectService: "Selecciona un servicio",
      confidenceHigh: "Alta",
      confidenceMedium: "Media",
      confidenceLow: "Baja",
      aiSuggested: "AI sugerido",
      confirmed: "Confirmado",
      confirm: "Confirmar",
      edit: "Editar",
      discard: "Descartar",
      pending: "Pendiente...",
      continueToFull: "Continuar al Cuestionario Completo",
      viewDetails: "Ver Detalles de Solicitud",
    },
  },
};
